import {resizeSelectedImages, resizeTargetPhotoList} from 'components/imaging/ResizedDasWebImage';
import {getCountryCode} from 'lib/PropertyUtils';

export const reportTypes = ['cma', 'rental'];

export const getCmaTemplateName = (sectionKey, version = 1) => {
  const basePath = `signature/cma/${version}/`;
  let templatePath;
  switch (sectionKey) {
    case 'NZ_TITLES': {
      templatePath = 'titles-nz';
      break;
    }
    default:
      throw new Error(`Unrecognized section key ${sectionKey}`);
  }
  return basePath + templatePath;
};

export const getComparableTemplateName = (sectionKey, version = 4) => {
  const countryCode = getCountryCode();
  const basePath = `signature/cma/${getGreCmaVersion(version)}/`;
  let comparableType;
  let templatePath;
  switch (sectionKey) {
    case 'COMPARABLE_LISTINGS':
    case 'COMPARABLE_RENTALS': {
      comparableType = 'listings';
      templatePath = getNonFeaturedTemplate(comparableType, countryCode, version);
      break;
    }
    case 'COMPARABLE_SALES': {
      comparableType = 'sales';
      templatePath = getNonFeaturedTemplate(comparableType, countryCode, version);
      break;
    }
    case 'FEATURED': {
      templatePath = getFeaturedTemplate(countryCode, version);
      break;
    }
    case 'COMPARABLE_LISTINGS_MAP': {
      comparableType = 'listings';
      templatePath = getMapTemplate(comparableType, countryCode, version);
      break;
    }
    case 'COMPARABLE_RENTALS_MAP': {
      comparableType = 'rentals';
      templatePath = getMapTemplate(comparableType, countryCode, version);
      break;
    }
    case 'COMPARABLE_SALES_MAP': {
      comparableType = 'sales';
      templatePath = getMapTemplate(comparableType, countryCode, version);
      break;
    }
    default: {
      throw new Error(`Unrecognized section key ${sectionKey}`);
    }
  }
  return basePath + templatePath;
};

export const resizePropertyImages = (targetProperty) => {
  const resizedTargetProperty = Object.assign({}, targetProperty);
  resizedTargetProperty.selectedImages = resizeSelectedImages(resizedTargetProperty.selectedImages);
  resizedTargetProperty.targetPhotoList = resizeTargetPhotoList(resizedTargetProperty.targetPhotoList);
  return resizedTargetProperty;
};

const getNonFeaturedTemplate = (comparableType, countryCode, version) => {
  switch (version) {
    case 1: {
      return `comparable-${comparableType}`;
    }
    case 2: {
      return `comparable-properties-v2-${countryCode}`;
    }
    default: {
      return `comparable-properties-${countryCode}`;
    }
  }
};

const getFeaturedTemplate = (countryCode, version) => {
  switch (version) {
    case 1: {
      throw new Error('Featured property should not be called with version 1');
    }
    case 2: {
      return 'featured-property';
    }
    default: {
      return `featured-property-${countryCode}`;
    }
  }
};

const getMapTemplate = (comparableType, countryCode, version) => {
  if (version === 1) {
    throw new Error('Comparable property map should not be called with version 1');
  } else {
    return 'comparable-item-map';
  }
};

const getGreCmaVersion = (version) => {
  switch (version) {
    case 1:
      return '1.0';
    case 2:
      return '2.0';
    default: {
      return version.toString();
    }
  }
};

const ReportUtilDefaults = {
  reportTypes,
  getComparableTemplateName,
  resizePropertyImages,
};

export default ReportUtilDefaults;
